import React from "react"
import { inject, observer } from "mobx-react"

import {
	Link
} from "react-router-dom";

const ListItem = (props) => {

	return (
		<div className="p-relative">
			<Link to={`/order/${props.item.id}`} className={`card__item card__item--is-${props.class}`} key={props.item.id}>
				<div className={`card__header`}>
					{props.item.attention && <i className="icon-info"/>}
					<div className={`card__dot card__dot--is-${props.class}`}></div>
				</div>

				<div className={`card__title `}>#{props.item.id}</div>
				<div className="card__products">
					{props.item.items.map((item, key) =>
						<div  className="card__product" key={`item${key}`}>
							<div className={"flex flex-column"}>
								<div class={" card__product-title"}>{key + 1}. {item.name}</div>
								<small><b>{ item.features_name }</b></small>
							</div>
							<div>
								<b>x{item.quantity}</b>
							</div>
						</div>
					)}
				</div>
			</Link>
			{ (props.item.slug_status === `new` || props.item.slug_status === `in_progress`) &&
			<div className="card__footer">
				<button className="card__button card__button--danger" onClick={() => props.Data.changeStatus("cancelled", props.item.id)}>
					<i className="las la-ban"></i>
				</button>
				<button className={`card__button card__button--${ props.item.slug_status === "new" ? "warning" : "completed" }`} onClick={() => props.Data.changeStatus(props.item.slug_status === "new" ? "in_progress" : (props.item.id_type === 1 ? "in_delivery" : "completed"), props.item.id)}>
					<i className="las la-check"></i>
				</button>
			</div>
			}

			{ (props.item.slug_status === `in_delivery`) &&
			<div className="card__footer">
				<button className="card__button card__button--danger" onClick={() => props.Data.changeStatus("cancelled", props.item.id)}>
					<i className="las la-ban"></i>
				</button>
				<a className={"card__button"} href={`http://maps.google.com/maps?saddr=${ props.item.address.address.split(" ").join("+") },${ props.item.address.zip }+${ props.item.address.city.split(" ").join("+") } `}>
					<i className="las la-car"></i>
				</a>
				<button className={`card__button card__button--completed`} onClick={() => props.Data.changeStatus("completed", props.item.id)}>
					<i className="las la-check"></i>
				</button>
			</div>
			}
		</div>
	);

}

export default inject('Data')(observer(ListItem))
